
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"path1",attrs:{"d":"M11 10h2v5h-2v-5z","fill":"#fff"}}),_c('path',{staticClass:"path2",attrs:{"d":"M12 16a1 1 0 100 2 1 1 0 000-2z","fill":"#fff"}}),_c('path',{staticClass:"path3",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.734 21.002a1 1 0 01-.865-1.5l9.265-16.005a1 1 0 011.731 0l9.266 16.004a1 1 0 01-.866 1.501H2.735zm16.797-2L12 5.994 4.469 19.002H19.53z","fill":"#fff"}}),_c('path',{staticClass:"path4",attrs:{"d":"M11 16h2v2h-2v-2z","fill":"#fff"}})])
          )
        }
      }
    